<template>
  <div v-if="Object.keys(editableItem).length" container>
    <div class="card _mbs _ps">
      <h2 class="_mbs">Edit {{ type }}</h2>
      <div grid="row wrap">
        <div :column="3" class="_mbxs" v-for="(field, i) in editableForm" :key="i">
          <label :for="field.id">
            {{ field.label }}:
            <span
              v-if="hasValidationError(field.id)"
              class="lips validation"
            >
              {{ validationMessage($v[field.id], field.validation) }}
            </span>
          </label>
          <template v-if="field.options">
            <select :name="field.id" :id="field.id" v-model="field.value">
              <option v-for="option in field.options" :value="option">
                {{ selectDropdownLabel(option, field.id) }}
              </option>
            </select>
          </template>
          <template v-else>
            <app-input :id="field.id" :name="field.id" :type="field.type" v-model="$v[field.id].$model"
                       :value="[field.id]"
                       @input="addressUpdated($event, field.id)"
            />
          </template>
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mts" column="4 +4">
          <button class="btn white --sm _mrxs" @click="$store.dispatch('toggleEditLocation')">Cancel</button>
          <button class="btn --sm" @click="submit()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { selectDropdownLabel } from '@/js/utilities'
  import states from '@/js/us-states'
  import AppInput from '@atoms/Input'
  import ZipCodeHelper from '@mixins/ZipCodeHelper'
  import { validationMessage } from '@/js/validation-messages'
  import { createNewEvent } from '@/js/open-enrollment/oe-event-detail-validation'

  export default {
    props: {
      editableItem: {
        type: Object,
        required: true
      },
      existingLocations: {
        type: Array,
        required: true
      },
      type: {
        type: String,
        required: false,
        default: 'Location'
      }
    },
    validations() {
      return createNewEvent(this.locationName, {
        locationName: this.locationName,
        addressLine1: this.getFormItem('addressLine1').value,
        addressLine2: this.getFormItem('addressLine2').value,
        city: this.getFormItem('city').value,
        state: this.getFormItem('state').value,
        zipCode: this.getFormItem('zipCode').value,
        eligibleEmployees: this.getFormItem('eligibleEmployees').value,
        // multilingualIndicator: this.getFormItem('multilingualIndicator').value,
        contactName: this.getFormItem('contactName').value,
        contactPhone: this.getFormItem('contactPhone').value,
        contactPhoneExt: this.getFormItem('contactPhoneExt').value,
        contactEmail: this.getFormItem('contactEmail').value,
        totalEmployees: this.$store.state.groupSelector.groupSettings.totalEmployeeQuantity,
        id: this.item.locationId
      }, this.existingLocations, true)
    },
    components: {
      AppInput
    },
    mixins: [
      ZipCodeHelper
    ],
    data() {
      return {
        item: {},
        editableForm: [
          {
            label: 'Location Name',
            type: 'text',
            id: 'locationName',
            value: this.editableItem.name
          },
          {
            label: 'Address Line 1',
            type: 'text',
            id: 'addressLine1',
            value: this.editableItem.location.addressLine1
          },
          {
            label: 'Address Line 2',
            type: 'text',
            id: 'addressLine2',
            value: this.editableItem.location.addressLine2
          },
          {
            label: 'Zip Code',
            type: 'text',
            id: 'zipCode',
            value: this.editableItem.location.zipCode
          },
          {
            label: 'City',
            type: 'text',
            id: 'city',
            value: this.editableItem.location.city
          },
          {
            label: 'State',
            type: 'text',
            id: 'state',
            value: this.editableItem.location.state,
            options: states
          },
          {
            label: 'Contact Name',
            id: 'contactName',
            type: 'text',
            value: this.editableItem.contactName ? this.editableItem.contactName : this.editableItem.contactInformation.name
          },
          {
            label: 'Contact Phone',
            id: 'contactPhone',
            type: 'tel',
            value: this.editableItem.contactPhone ? this.editableItem.contactPhone : this.editableItem.contactInformation.phone
          },
          {
            label: 'Contact Phone Extension',
            id: 'contactPhoneExt',
            type: 'text',
            value: this.editableItem.contactExt ? this.editableItem.contactExt : this.editableItem.contactInformation.phoneExt
          },
          {
            label: 'Contact Email',
            id: 'contactEmail',
            type: 'email',
            value: this.editableItem.contactEmail ? this.editableItem.contactEmail : this.editableItem.contactInformation.email
          },
          {
            label: 'Eligible Employees at Location',
            type: 'number',
            id: 'eligibleEmployees',
            value: this.editableItem.eligibleEmployees
          }
          // {
          //   label: 'Multilingual Employees',
          //   type: 'text',
          //   id: 'multilingualIndicator',
          //   value: this.editableItem.multilingualIndicator === 'Y',
          //   options: [ true, false ]
          // },
        ],

        locationName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        eligibleEmployees: '',
        multilingualIndicator: '',
        contactName: '',
        contactPhone: '',
        contactPhoneExt: '',
        contactEmail: '',
        totalEmployees: this.$store.state.groupSelector.groupSettings.totalEmployeeQuantity
      }
    },
    methods: {
      setValue(event, value) {
        if (this.$v[event.id]) {
          this[event.id] = value
          this.$v[event.id].$model = this[event.id]
          this.validationMessage(this.$v[event.id])
        }
      },
      validationMessage,
      hasValidationError(id) {
        return !!this.$v[id] && this.$v[id].$error
      },
      setAllValues() {
        this.editableForm.forEach((item) => {
          this.setValue(item, item.value)
        })
      },
      selectDropdownLabel,
      getFormItem(prop) {
        return this.editableForm.filter((field) => {
          return field.id === prop
        })[0]
      },
      addressUpdated(e, id) {
        if ((e.length === 5 || e.length === 9) && id === 'zipCode') {
          this.suggestLocationFromZipCode(e)
            .then((suggestion) => {
              if (!suggestion) return
              if (suggestion.city) this.getFormItem('city').value = suggestion.city
              if (suggestion.state) this.getFormItem('state').value = suggestion.state
              this.addressUpdated()
            })
        }
      },
      prepareEditableItem() {
        const copy = { ...this.editableItem }
        copy.name = this.locationName
        copy.location.addressLine1 = this.addressLine1
        copy.location.addressLine2 = this.addressLine2
        copy.location.city = this.city
        copy.location.state = this.state
        copy.location.zipCode = this.zipCode
        copy.eligibleEmployees = this.eligibleEmployees
        copy.contactName = this.contactName
        copy.contactPhone = this.contactPhone
        copy.contactExt = this.contactExt
        copy.contactEmail = this.contactEmail
        // copy.multilingualIndicator = this.getFormItem('multilingualIndicator').value ? 'Y' : 'N'

        return copy
      },
      submit() {
        console.log(this.prepareEditableItem())
        this.$emit('onEditSubmit', this.prepareEditableItem())
      }
    },
    watch: {
      editableItem(val) {
        this.item = val
      }
    },
    mounted() {
      this.$v.$touch()
      this.setAllValues()
    },
    beforeMount() {
      this.item = { ...this.editableItem }
    }
  }
</script>

<style>
  .card {
    padding: 1rem 1.5rem;
  }
</style>
